import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AvContentContainerComponent } from '../av-content-container/av-content-container.component';
import { AvEmptyStateComponent } from '../av-empty-state/av-empty-state.component';
import { AvLanguageDropdownComponent } from '../av-language-dropdown/av-language-dropdown.component';
import { AvThemeToggleComponent } from '../theme-toggle/theme-toggle.component';

@Component({
  selector: 'av-unsupported-device',
  standalone: true,
  imports: [
    TranslateModule,
    AvContentContainerComponent,
    AvEmptyStateComponent,
    AvLanguageDropdownComponent,
    AvThemeToggleComponent,
  ],
  templateUrl: './av-unsupported-device.component.html',
  styleUrls: ['./av-unsupported-device.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class AvUnsupportedDeviceComponent {}
